import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Header = ({ navigate }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleNavigation = (path) => {
    if (navigate) {
      navigate(path);
    }
  };
  
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };
  
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-gray-950/95 text-white py-4 md:py-5 px-4 md:px-8 border-b border-gray-800 transition-all duration-300 backdrop-blur-sm ${
      scrolled ? 'shadow-lg shadow-gray-900/30' : ''
    }`}>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex items-center">
            <div className="mr-3 text-blue-500 hidden md:block">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 000 2h10a1 1 0 100-2H3zm0 4a1 1 0 000 2h10a1 1 0 100-2H3zm0 4a1 1 0 100 2h10a1 1 0 100-2H3z" clipRule="evenodd" />
                <path fillRule="evenodd" d="M17 6a1 1 0 10-2 0v8a1 1 0 102 0V6z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <h1 
                className="text-2xl md:text-3xl font-bold cursor-pointer font-sora tracking-wide group" 
                onClick={() => handleNavigation('/')}
              >
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600">Electoral</span> <span className="text-white group-hover:text-blue-200 transition-colors">Grants</span>
              </h1>
              <p className="text-gray-400 font-inter text-sm tracking-wide">Illuminating patterns in federal funding allocation</p>
            </div>
          </div>
          
          {/* Navigation menu */}
          <nav className="mt-4 md:mt-0">
            <ul className="flex space-x-6 items-center">
              <li>
                <button 
                  onClick={() => handleNavigation('/')}
                  className={`${isActive('/') 
                    ? 'text-blue-400 font-medium' 
                    : 'text-white'} font-inter hover:text-blue-400 transition-colors relative py-2 group`}
                >
                  <span>Dashboard</span>
                  {isActive('/') && (
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-500"></span>
                  )}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/about')}
                  className={`${isActive('/about') 
                    ? 'text-blue-400 font-medium' 
                    : 'text-white'} font-inter hover:text-blue-400 transition-colors relative py-2 group`}
                >
                  <span>About</span>
                  {isActive('/about') && (
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-500"></span>
                  )}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
